import { useMemo,useState,useRef,useEffect } from "react";
import * as d3 from "d3";
import styles from './HeatmapConfusion.module.css';

// const MARGIN = { top: 10, right: 50, bottom: 30, left: 50 }
const MARGIN = { top: 0, right: 0, bottom: 0, left: 0 }

export default function HeatmapConfusion({ width, height, data }){

  const wrapRef=useRef(null);
  const [wrapWidth,setWrapWidth]=useState(0);
  const [wrapHeight,setWrapHeight]=useState(0);

  const [min=0, max=0]=d3.extent(data.map(d=>d.value));
  const allXGroups=useMemo(()=>[...new Set(data.map(d=>d.x))],[data])

  const COLORS = [
    "#cce9f6",
    "#066aff63",
    "#066aff"
  ];

  useEffect(()=>{
      const resizeObserver=new ResizeObserver((entries)=>{
        for(let entry of entries){
          if(entry.target && document.body.contains(entry.target)){
            const {width,height}=wrapRef.current.getBoundingClientRect();
            setWrapWidth(width);
            setWrapHeight(height);
            // setBoundsWidth(width - MARGIN.right - MARGIN.left)
            // setBoundsHeight(height - MARGIN.top - MARGIN.bottom)
          }
        }
      })

      if(wrapRef.current){
        resizeObserver.observe(wrapRef.current)
      }

      return()=>{
        if(wrapRef.current){
          resizeObserver.unobserve(wrapRef.current);
        }
        resizeObserver.disconnect();
      }
  },[])

  const THRESHOLDS = useMemo(()=>{
      const step=(max-min)/COLORS.length
      return Array.from({length:COLORS.length+1},(_,i)=>min+i*step)
  },[min,max,COLORS])

  const COLOR_LEGEND_HEIGHT = allXGroups.length;

  const [hoveredCell, setHoveredCell] = useState(null)

  const colorScale = d3
  .scaleLinear()
  .domain(THRESHOLDS)
  .range(COLORS)

  return (
    <div 
    ref={wrapRef}
    className={styles['wrap']}>
      <Renderer
        width={wrapWidth}
        // height={wrapHeight - COLOR_LEGEND_HEIGHT}
        height={wrapHeight}
        data={data}
        setHoveredCell={setHoveredCell}
        colorScale={colorScale}
      />
      <Tooltip 
          interactionData={hoveredCell} 
          width={width} 
          height={height - COLOR_LEGEND_HEIGHT}
      />
      {/* <div className={styles['color-legend']}>
        <ColorLegend
          height={COLOR_LEGEND_HEIGHT}
          width={200}
          colorScale={colorScale}
          interactionData={hoveredCell}
        />
      </div> */}
      {/* <span className={styles['yName']}>Class</span>
      <span className={styles['xName']}>Prediction</span> */}
    </div>
  )
}

const ColorLegend = ({ height, colorScale, width, interactionData }) => {

  const COLOR_LEGEND_MARGIN = { top: 0, right: 0, bottom: 50, left: 0 }
  const canvasRef = useRef(null)

  const boundsWidth =
    width - COLOR_LEGEND_MARGIN.right - COLOR_LEGEND_MARGIN.left
  const boundsHeight =
    height - COLOR_LEGEND_MARGIN.top - COLOR_LEGEND_MARGIN.bottom

  const domain = colorScale.domain()
  const min = domain[0]
  const max = domain[domain.length - 1]
  const xScale = d3
    .scaleLinear()
    .range([0, boundsWidth])
    .domain([min, max])

  const ticks=xScale.ticks(4)
  if (!ticks.includes(min))ticks.unshift(min);
  if (!ticks.includes(max))ticks.push(max);
  
  const evenlySpacedTicks=d3.range(min,max,(max-min)/4)
  if(!evenlySpacedTicks.includes(min)) evenlySpacedTicks.unshift(min)
  if(!evenlySpacedTicks.includes(max)) evenlySpacedTicks.unshift(max)

  const allTicks = evenlySpacedTicks.map(tick => {
    return (
      <>
        <line
          x1={xScale(tick)}
          x2={xScale(tick)}
          y1={boundsHeight + 5}
          y2={boundsHeight+ 8}
          stroke="rgba(0,0,0,.7)"
          // strokeDasharray={3}
          strokeWidth="1px"
          strokeLinecap="round"
        />
        <text
          x={xScale(tick)}
          y={boundsHeight + 20}
          fontSize={9}
          textAnchor="middle"
        >
        {parseInt(tick)}
        </text>
      </>
    )
  })

  const hoveredValue = interactionData?.value
  const x = hoveredValue ? xScale(hoveredValue) : null
  const triangleWidth =9 
  const triangleHeight =6 
  const triangle = 
    <g className={styles['triangle']}
    transform={`translate(${x-6}, 0)`}
    >
    {/* <polygon
      points={`${x},0 ${x - triangleWidth / 2},${-triangleHeight} ${x +
        triangleWidth / 2},${-triangleHeight}`}
      fill="white"
      strokeLinejoin="round" 
      strokeWidth="4"
      stroke="black"
    /> */}
    {/* <path
    d={
      `M${x},${-triangleHeight-5}
      Q${x},${-triangleHeight-15} ${x-5},${-triangleHeight-15}
      L${x-5},${-triangleHeight-20}
      Q${x},${-triangleHeight-25} ${x+5},${-triangleHeight-20}
      L${x+5},${-triangleHeight-15}
      Q${x},${-triangleHeight-15} ${x},${-triangleHeight-5} Z`}
    /> */}
    <path  
    transform={`translate(-1, -10) scale(.8)`}
    d="M.47.47A.75.75,0,0,1,1.446.4L1.53.47,8,6.939,14.47.47A.75.75,0,0,1,15.446.4L15.53.47a.75.75,0,0,1,.073.977l-.073.084-7,7a.75.75,0,0,1-.977.073L7.47,8.53l-7-7A.75.75,0,0,1,.47.47Z"
    strokeLinejoin="round" 
    strokeWidth="1"
    stroke={`${x?'#f4f5fb':'rgba(0,0,0,.1'}`}
    fill={`${x?'#f4f5fb':'rgba(0,0,0,.1'}`}
    >
    </path>
    <text
      x={5}
      y={-14}
      fontSize={10}
      fontWeight="bold"
      textAnchor="middle"
      fill="#f4f5fb"
      >
        {hoveredValue}
    </text>
    </g>

  const fillRoundedRect=(context,x,y,width,height,radius)=>{
    context.beginPath();
    context.moveTo(x+radius,y);
    context.lineTo(x+width-radius,y);
    context.quadraticCurveTo(x+width,y,x+width,y+radius);
    context.lineTo(x+width,y+height-radius);
    context.quadraticCurveTo(x+width,y+height,x+width-radius,y+height);
    context.lineTo(x+radius,y+height);
    context.quadraticCurveTo(x,y+height,x,y+height-radius);
    context.lineTo(x,y+radius);
    context.quadraticCurveTo(x,y,x+radius,y);
    context.closePath();
    context.fill();
  }

  useEffect(() => {
    const canvas = canvasRef.current
    const context = canvas?.getContext("2d")

    if (!context) {
      return
    }

    for (let i = 0; i < boundsWidth; ++i) {
      context.fillStyle = colorScale((max * i) / boundsWidth)
      // context.fillRect(i, 0, 1, boundsHeight)
      fillRoundedRect(context,i, 0, 1, boundsHeight,2)

    }
  }, [width, height])

  return (
    <div>
        <div className={styles['color-legend-wrap']}>
        {/* <p className={styles['color-legend-text']}> */}
        <span className={styles['color-legend-text']}>Model Counts</span>
        <span className={styles['color-legend-text']}>{parseInt(min)}</span>
        {/* </p> */}
        <div
          style={{
            position: "relative",
            transform: `translate(${COLOR_LEGEND_MARGIN.left}px,
              ${COLOR_LEGEND_MARGIN.top}px`
          }}
        >
          <canvas 
          className={styles['color-legend-canvas']}
          ref={canvasRef} 
          minWidth={boundsWidth} 
          maxWidth={boundsWidth} 
          width={boundsWidth} 
          height={'8px'} 
          />
          <svg
            width={boundsWidth}
            height={boundsHeight}
            style={{ position: "absolute", top: 0, left: 0, overflow: "visible" }}
          >
            {/* {allTicks} */}
            {triangle}
          </svg>
        </div>
        <span className={styles['color-legend-text']}>{parseInt(max)}</span>
      </div>
    </div>
  )
}

function Tooltip({ interactionData, width, height }){
  if (!interactionData) {
    return null
  }

  return (interactionData.value!=0&&
  <div
      style={{
        width,
        height,
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none"
      }}
    >
      <div
        className={styles['tooltip']}
        style={{
          position: "absolute",
          left: interactionData.xPos,
          top: interactionData.yPos
        }}
      >
        <TooltipRow label={"Class"} value={interactionData.yLabel} />
        <TooltipRow label={"Prediction"} value={interactionData.xLabel} />
        <TooltipRow label={"Model Counts"} value={interactionData.value} />
      </div>
    </div>
  )
}

const TooltipRow = ({ label, value }) => (
  <div>
    <p>
      <span>{label}: </span>
      <span>{value}</span>
    </p>
  </div>
)

const Renderer = ({
    width,
    height,
    data,
    setHoveredCell,
    colorScale
  }) => {
    const boundsWidth = width - MARGIN.right - MARGIN.left
    const boundsHeight = height - MARGIN.top - MARGIN.bottom
  
    const allYGroups = useMemo(() => [...new Set(data.map(d => d.y))], [data])
    const allXGroups = useMemo(() => [...new Set(data.map(d => d.x))], [data])

    const [min = 0, max = 0] = d3.extent(data.map(d => d.value))

    const heatmapRef=useRef(null);
    const labelRef=useRef(null);
  
    const xScale = useMemo(() => {
      return d3
        .scaleBand()
        .range([0,boundsWidth])
        .domain(allXGroups)
        // .padding(0.1)
    }, [data, width])
  
    const yScale = useMemo(() => {
      return d3
        .scaleBand()
        .range([0,boundsHeight])
        .domain(allYGroups)
        // .padding(0.1)
    }, [data, height])
  
    const allRects = data.map((d, i) => {
      const xPos = xScale(d.x)
      const yPos = yScale(d.y)
  
      if (d.value === null || !xPos || !yPos) {
        return
      }
  
      return (
        <rect
            key={i}
            r={4}
            // rx={2}
            x={xPos}
            y={yPos}
            className={styles['cell']}
            width={xScale.bandwidth()}
            height={yScale.bandwidth()}
            fill={d.value ? colorScale(d.value) : "#f2f3f78c"}
            onMouseEnter={e => {
                setHoveredCell({
                    xLabel:d.x,
                    yLabel:d.y,
                    xPos: xPos + xScale.bandwidth() + MARGIN.left,
                    yPos: yPos + xScale.bandwidth() / 2 + MARGIN.top,
                    value: d.value
                })
            }}
            onMouseLeave={() => setHoveredCell(null)}
            cursor="pointer"
        />
      )
    })
    
    const NUM_TICKS=7
    const xScaleAxis=d3.scaleLinear()
    .domain([d3.min(data,d=>+d.x),d3.max(data,d=>+d.x)])
    .range([0,boundsWidth])

    const xAxis=d3.axisBottom(xScaleAxis)
      .ticks(5)
      .tickFormat(d3.format('.2s'))

    const xLabels=useMemo(()=>{
      return(
        <g
        className="x-axis"
        transform={`translate(0,${boundsHeight+10})`}
        ref={node=>d3.select(node).call(xAxis)}
        />
      )

    },[data,width])


    const yScaleAxis=d3.scaleLinear()
    .domain([d3.min(data,d=>+d.y),d3.max(data,d=>+d.y)])
    .range([0,boundsHeight])

    const yAxis=d3.axisLeft(yScaleAxis)
      .ticks(5)
      .tickFormat(d3.format('.2s'))

    const yLabels=useMemo(()=>{
      return(
        <g
        className="y-axis"
        transform={`translate(-10,0)`}
        ref={node=>d3.select(node).call(yAxis)}
        />
      )
    },[data,height])

    useEffect(()=>{
        const heatmapLayer=d3.select(heatmapRef.current);
        const labelLayer=d3.select(labelRef.current);
        // const zoom = d3.zoom()
        //     .scaleExtent([1, 10])
        //     // .extent([[0,0],[boundsWidth,boundsHeight]])
        //     .translateExtent([[0, 0], [boundsWidth, boundsHeight]])
        //     .on('zoom', (event)=>{
        //         heatmapLayer.attr('transform',event.transform);
        //         labelLayer.select('.x-axis').call(xAxis.scale(event.transform.rescaleX(xScaleAxis)))
        //         labelLayer.select('.y-axis').call(yAxis.scale(event.transform.rescaleX(yScaleAxis)))
        //     });

        // heatmapLayer.call(zoom);
        // heatmapLayer.on('dblclick.zoom',()=>{
        //     heatmapLayer.transition().duration(250).call(zoom.transform,d3.zoomIdentity);
        // });

        labelLayer
        .selectAll('.domain')
        .attr("stroke-width","2px")
        .attr("stroke-line-cap","round")
        .attr("stroke","#ededed");

    },[data,width,height])
  
    return (
        <>
        <svg
            width={boundsWidth}
            height={boundsHeight}
            style={{ position: "absolute"}}
            transform={`translate(${[MARGIN.left, MARGIN.top].join(",")})`}
            onMouseLeave={() => setHoveredCell(null)}>
            <g
                ref={heatmapRef}
                width={boundsWidth}
                height={boundsHeight}>
                <rect
                width={boundsWidth}
                height={boundsHeight}
                fill={'white'}
                ></rect>
                {allRects}
            </g>
            </svg>
        <div 
        style={{
          width:boundsWidth,
          height:boundsHeight,
          marginLeft:MARGIN.left,
          marginTop:MARGIN.top,
        }}
        className={styles['chart-transition']}></div>
        {/* <svg
            width={width}
            height={height}>
            <g
                ref={labelRef}
                width={boundsWidth}
                height={boundsHeight}
                transform={`translate(${[MARGIN.left, MARGIN.top].join(",")})`}>
                {xLabels}
                {yLabels}
            </g>
        </svg> */}
        </>
    )
  }

